import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import graphqlQuery from 'graphs/queries/ProductsPaginated.graphql'
import withConnectionQuery from 'components/withConnectionQuery'
import fields from 'fields/products'

const RouteProducts = props => (
  <Fragment>
    <h3>Products</h3>
    <PaginatedConnectionTable {...props} fields={fields} />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'products'
})(RouteProducts)



// WEBPACK FOOTER //
// ./src/routes/admin/products/index.js